import { render } from "./ticket_details.vue?vue&type=template&id=2296d8d2&scoped=true"
import script from "./ticket_details.vue?vue&type=script&lang=js"
export * from "./ticket_details.vue?vue&type=script&lang=js"

import "./ticket_details.vue?vue&type=style&index=0&id=2296d8d2&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2296d8d2"]])

export default __exports__